var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21875 2.5C3.95987 2.5 3.75 2.70987 3.75 2.96875C3.75 3.22763 3.95987 3.4375 4.21875 3.4375H15.7812C16.0401 3.4375 16.25 3.22763 16.25 2.96875C16.25 2.70987 16.0401 2.5 15.7812 2.5H4.21875ZM10.5034 4.62588C10.5132 4.63572 10.5226 4.6458 10.5317 4.65611L15.3611 9.48551C15.6051 9.72958 15.6051 10.1253 15.3611 10.3694C15.117 10.6135 14.7213 10.6135 14.4772 10.3694L10.6912 6.58336L10.6912 16.875C10.6912 17.2202 10.4113 17.5 10.0662 17.5C9.72098 17.5 9.44116 17.2202 9.44116 16.875L9.44116 6.57196L5.642 10.3711C5.39792 10.6152 5.00219 10.6152 4.75811 10.3711C4.51403 10.127 4.51403 9.73132 4.75811 9.48724L9.56948 4.67588C9.5838 4.658 9.59925 4.64072 9.61583 4.62415C9.80861 4.43136 10.096 4.39085 10.3286 4.50261C10.3918 4.53249 10.4511 4.57359 10.5034 4.62588Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowTop);
export default __webpack_public_path__ + "static/media/ic_arrow_top.881367e46b143f5c23a071bc589aa4fc.svg";
export { ForwardRef as ReactComponent };